import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ProjectFileService {
  private apiUrl = '/api/graphql';

  constructor(private http: HttpClient) { }

  getGroupedProjectFiles(projectId: number) {
    const query = `
      query {
        projectFilesGrouped(projectId: ${projectId})
      }
    `;
    return this.http.post<any>(this.apiUrl, { query });
  }

  getProjectFiles(projectId: any, type: string = null) {
    const query = `
      query GetProjectFiles($projectId: ID!, $type: String) {
        projectFiles(projectId: $projectId, type: $type) {
          id
          displayName
          fileName
          fileType
          url
          objectId
          bucketFolder
          group
          type
          parentId
        }
      }
    `;
  
    const variables: any = {
      projectId: projectId,
      type: type
    };
    
    return this.http.post<any>(this.apiUrl, {
      query,
      variables
    });
  }

  getProjectFileById(id: any) {
    const query = `
      query {
        projectFileById(id: "${id}") {
          id
          displayName
          fileName
          fileType
          url
          objectId
          bucketFolder
          group
          type
        }
      }
    `;
    return this.http.post<any>(this.apiUrl, { query });
  }

  projectFilesByIds(ids: any) {
    const query = `
      query ($ids: [ID!]) {
        projectFilesByIds(ids: $ids) {
          id
          displayName
          fileName
          fileType
          url
          objectId
          bucketFolder
          group
          type
        }
      }
    `;
    return this.http.post<any>(this.apiUrl, {
      query,
      variables: { ids }
    });
  }

  uploadProjectFile(input: any) {
    const mutation = `
      mutation UploadProjectFile($input: ProjectFileInput) {
        uploadProjectFile(input: $input) {
          id
          displayName
          fileName
        }
      }
    `;
    return this.http.post<any>(this.apiUrl, {
      query: mutation,
      variables: { input },
    });
  }

  bulkUploadProjectFiles(inputs: any[]) {
    const mutation = `
      mutation BulkUploadProjectFiles($inputs: [ProjectFileInput!]!) {
        bulkUploadProjectFiles(inputs: $inputs) {
          id
          displayName
          fileName
        }
      }
    `;
    return this.http.post<any>(this.apiUrl, {
      query: mutation,
      variables: { inputs },
    });
  }

  updateProjectFile(id: number, input: any) {
    const mutation = `
      mutation UpdateProjectFile($id: ID!, $input: ProjectFileInput) {
        updateProjectFile(id: $id, input: $input) {
          id
          displayName
          fileName
        }
      }
    `;
    return this.http.post<any>(this.apiUrl, {
      query: mutation,
      variables: { id, input },
    });
  }

  deleteProjectFile(id: number) {
    const mutation = `
      mutation {
        deleteProjectFile(id: ${id})
      }
    `;
    return this.http.post<any>(this.apiUrl, { query: mutation });
  }

  bulkDeleteProjectFiles(ids) {
    const mutation = `
      mutation BulkDeleteProjectFiles($ids: [ID!]!) {
        bulkDeleteProjectFiles(ids: $ids)
      }
    `;

    return this.http.post<any>(this.apiUrl, {
      query: mutation,
      variables: { ids }
    });
  }

  getProjectFileTree(projectId: number) {
    const query = `
      query GetProjectFileTree($projectId: Int!) {
        getProjectFileTree(projectId: $projectId)
      }
    `;
    return this.http.post<any>(this.apiUrl, {
      query,
      variables: { projectId },
    });
  }

  getProjectFileChildren(projectId: number, parentId: number) {
    const query = `
      query GetProjectFileChildren($projectId: Int!, $parentId: Int!) {
        getProjectFileChildren(projectId: $projectId, parentId: $parentId)
      }
    `;
    return this.http.post<any>(this.apiUrl, {
      query,
      variables: { projectId, parentId },
    });
  }

  // If you expose restore and move operations in GraphQL, add these:
  restoreProjectFile(id: number) {
    const mutation = `
      mutation RestoreFile($id: ID!) {
        restoreProjectFile(id: $id)
      }
    `;
    return this.http.post<any>(this.apiUrl, {
      query: mutation,
      variables: { id },
    });
  }

  moveProjectFile(id: number, newParentId: number) {
    const mutation = `
      mutation MoveFile($id: ID!, $newParentId: Int!) {
        moveProjectFile(id: $id, newParentId: $newParentId)
      }
    `;
    return this.http.post<any>(this.apiUrl, {
      query: mutation,
      variables: { id, newParentId },
    });
  }
}
